import { AxiosError } from 'axios'
import { ApiCCApp } from '../api/endpoints'
import type { PrequalAndAppSubmissionBody } from '../../types/prequalAndAppSubmission.types'
import { getApplicationSubmissionUrl } from '../../../constants/ccAppServiceUri'
import type { ApplicationSubmissionResponse } from '../../types'

export interface ApplicationSubmissionError {
  response: {
    status: number
    statusText: string
    data: {
      error: string
      failure: {
        error: string
      }
    }
  }
}

export type ErrorType = ApplicationSubmissionError & AxiosError

const submitApplication = async (
  body: PrequalAndAppSubmissionBody
): Promise<ApplicationSubmissionResponse> => {
  const applicationSubmissionUrl = getApplicationSubmissionUrl()

  const response = await ApiCCApp.post<PrequalAndAppSubmissionBody, ApplicationSubmissionResponse>(
    applicationSubmissionUrl,
    body
  )
  return response.data
}

export default submitApplication
